module.exports = __webpack_public_path__ + "img/taiwanfengweirou.8e3c937c.jpg";